/* Models */

export interface Pagination {
  offset: number;
  limit: number;
  sortField?: string;
  sortOrder?: number;
}

export interface Page<T> {
  offset: number;
  limit: number;
  count: number;
  items: T[];
}

/* Functions */
export function itemsToPage<T>(params: Partial<Pagination>, items: T[]): Page<T> {
  const offset = params.offset ?? 0;
  const limit = params.limit ?? 5;
  return {
    offset,
    limit,
    items: [...items].slice(offset, offset + 5),
    count: items.length,
  };
}

export const searchQueryInField = <T>(query: string, item: T, fields: (keyof T)[]): boolean => {
  const queryParts = query.toLowerCase().split(' ');
  const scope = fields.map((f) => `${item[f]}`.toLowerCase()).join(' ');
  return queryParts.every((q) => scope.includes(q));
};
